import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {
	GetLocal,
	FetchService,
	SetLocal
} from "../../../Base/BaseControl";

export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [getPdf, setPdf] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [getIPGType, setIPGType] = useState(null);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('OwnersSession')
		};
		FetchService("Owner/Residential/Request/ShowModernizationToll", inputValue, ShowModernizationTollSuccess);
	}, []);

	const ShowModernizationTollSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.ModernizationTollList);
		setIPGType(ServiceResult.IPGType)
		SetLocal("IPGType",ServiceResult.IPGType)
	}

	const PaymentAction = (row) => {
		IPGPaymentRequest();
	}

	const ViewFish = (row) => {
		var inputValue = {
			session: GetLocal('OwnersSession'),
			serialNumber: row.SerialNumber
		};
		FetchService("Owner/Residential/Report/ShowRenovationChargesReport", inputValue, ShowRenovationChargesReportSuccess);
	}

	const ShowRenovationChargesReportSuccess = (ServiceResult) => {
		setPdf("data:application/pdf;base64," + ServiceResult);
		setShowModal(true)
	}

	const IPGPaymentRequest = () => {
		var inputValue = {
			session: GetLocal('OwnersSession')
		};
		if (getIPGType === 1) {
			FetchService("Owner/Residential/Request/IPGPaymentRequestByNovin", inputValue, IPGPaymentRequestSuccess);
		} else if (getIPGType === 0) {
			FetchService("Owner/Residential/Request/IPGPaymentRequest", inputValue, IPGPaymentRequestSuccess);
		}
	}

	const IPGPaymentRequestSuccess = (ServiceResult) => {
		window.location = ServiceResult.RedirectURL + '&returnURL=' + window.location.protocol + '//' + window.location.host + '/ReturnFromIPG/'
	}

	return (
		<div>
			<GridControl
				data={getServiceResult}
				headers={["Year", "Amount", "PaymentDeadline", "PaymentDate", "Status"]}
				customHeaders={{ "Year": "سال", "Amount": "قابل پرداخت", "PaymentDeadline": "مهلت پرداخت", "PaymentDate": "تاریخ پرداخت", "Status": "وضعیت", "ViewFish": "مشاهده فیش", "PaymentAction": "پرداخت" }}
				PaymentAction={PaymentAction}
				ViewFish={ViewFish}
			/>

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
